import React from 'react';
import Icon from '@client/components/icons/Icon';
import iconStyles from '@client/shared/fonts/icomoon/icomoonIcons.scss';
import styles from './noDonation.scss';

export default function NoDonations() {
  return (
    <div className={styles.noDonation}>
      <Icon iconClassName={iconStyles.iconNoGift} className={styles.icon} />
      <p>Inga gåvor än</p>
    </div>
  );
}
